
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';
import { AccountService } from '../../../@core/services/account.service';

@Component({
  selector: 'nb-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {

  redirectDelay: number = 1000;
  constructor(protected service: AccountService,
    protected router: Router) {
  }

  ngOnInit(): void {
    this.logout();
  }

  logout(): void {
    this.service
      .logout()
      .pipe(first())
      .subscribe({
        next: () => {
          setTimeout(() => {
            return this.router.navigateByUrl("/account/login");
          }, this.redirectDelay);
        },
      }
      );
  }
}
